var React = require('react');

function QuoteInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M25,42V21.247q0-8.482,4.583-13.959A22.144,22.144,0,0,1,42,0V9.223a13.617,13.617,0,0,0-3.917,1.812,7.872,7.872,0,0,0-2.334,2.553,9.352,9.352,0,0,0-1.083,3.417,33.112,33.112,0,0,0-.25,4.242V23.47H42V42ZM0,42V21.247Q0,12.765,4.584,7.288A22.141,22.141,0,0,1,17,0V9.223a13.617,13.617,0,0,0-3.917,1.812,7.429,7.429,0,0,0-2.291,2.553,10.525,10.525,0,0,0-1.084,3.417,28.569,28.569,0,0,0-.292,4.242V23.47H17V42Z","fill":"#fff","opacity":"0.13"}));
}

QuoteInline.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42"};

module.exports = QuoteInline;

QuoteInline.default = QuoteInline;
